import ProductNav from '../../common/ProductNav';
import { generalKey } from '../../config/pageConfig';
import JP_Bundles from './JP';
import GS_Bundles from './GS';
import getLocal from '@/app/utils/getLocal';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

const Index = () => {
    const { locale = 'us' } = getLocal();

    const { gloproductlist } = useGlobal();
    const { buyLink } = getProductFromGeneralKey({ gloproductlist, generalKey });
    return (
        <>
            <ProductNav activeTab={'Bundles'} buyLink={buyLink} />
            {locale === 'jp' ? <JP_Bundles /> : <GS_Bundles />}
        </>
    );
};
export default Index;
